import Image from 'next/image';

import { cn } from '@/lib/utils';

import dots from '@/public/career/dots-background-white.svg';

/**
 * The light-surface twin of [DotsBackgroundDark] (Figma node 9890:158543) — the
 * same pixel grid, drawn in near-black instead of the light green.
 *
 * The artwork is 959×202 in the design, so it carries that width in rem and
 * lets the height follow — scaling it is a matter of overriding the width.
 * Positioning is left to the caller, through className.
 */
export default function DotsBackgroundWhite({
  className,
}: {
  className?: string;
}) {
  return (
    <Image
      className={cn(
        // the design halves an artwork already drawn at 5% — the grid is barely
        // there on purpose, a texture rather than a pattern
        'pointer-events-none h-auto w-[119.875rem] max-w-none select-none opacity-50',
        // the grid fades out over its bottom quarter rather than ending on a hard edge
        '[mask-image:linear-gradient(to_bottom,#000_75.83%,transparent_100%)]',
        className,
      )}
      src={dots}
      alt=""
      aria-hidden
    />
  );
}
